import { Component, Input, ChangeDetectionStrategy} from '@angular/core';
import { InstellingBron, RInstelling } from '@cumlaude/service-contract';

@Component({
	selector: 'app-instelling-labels',
	templateUrl: './instelling-labels.component.html',
	styleUrl: './instelling-labels.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstellingLabelsComponent {
	@Input()
	instelling!: RInstelling;

	@Input()
	toonBestuur = true;

	@Input()
	toonVSO = true;

	InstellingBron = InstellingBron;
}
